"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, Checkbox, classNames, FlexColumn, Form, FormControl, Input, ItemAvatar, ItemContent, Link, TextBody } from "@opensea/ui-kit";
import { Check } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { Item } from "../../../../../components/Item";
export const AcknowledgeEmailSignupStep = t0 => {
  const $ = _c(40);
  const {
    onSubmit,
    initialEmail
  } = t0;
  const t = useTranslations("wallet.AcknowledgeEmailSignupStep");
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  let t1;
  if ($[0] !== onSubmit) {
    t1 = async () => {
      setSubmitting(true);
      await onSubmit();
    };
    $[0] = onSubmit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onContinue = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("email");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("h-14 rounded-xl bg-bg-primary pr-3");
    t4 = <Button disabled={true} icon={Check} size="sm" type="submit" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== initialEmail) {
    t5 = <Input autoFocus={true} className={t3} endEnhancer={t4} value={initialEmail} />;
    $[6] = initialEmail;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <FormControl hideLabel={true} label={t2}>{t5}</FormControl>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames("gap-4 rounded-xl border-0");
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t.rich("termsText", {
      tosLink: _temp,
      touLink: _temp2,
      privacyLink: _temp3,
      privyLink: _temp4
    });
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <ItemContent><TextBody className="text-left" color="text-secondary" size="sm">{t8}</TextBody></ItemContent>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== agreedToTerms) {
    t10 = () => {
      setAgreedToTerms(!agreedToTerms);
    };
    $[16] = agreedToTerms;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== agreedToTerms || $[19] !== t10) {
    t11 = <ItemAvatar className=""><Checkbox checked={agreedToTerms} className="size-5" onClick={t10} /></ItemAvatar>;
    $[18] = agreedToTerms;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <FlexColumn className={t7}><Item className="" variant="unstyled">{t9}{t11}</Item></FlexColumn>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = !agreedToTerms;
  let t14;
  if ($[24] !== t) {
    t14 = t("continue");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== onContinue || $[27] !== submitting || $[28] !== t13 || $[29] !== t14) {
    t15 = <FlexColumn className="gap-4"><Button autoFocus={true} disabled={t13} isLoading={submitting} onClick={onContinue} size="lg">{t14}</Button></FlexColumn>;
    $[26] = onContinue;
    $[27] = submitting;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("walletCreationMessage");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <CenterAligned className="w-full"><TextBody color="text-secondary" size="xs">{t16}</TextBody></CenterAligned>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t12 || $[36] !== t15 || $[37] !== t17 || $[38] !== t6) {
    t18 = <FlexColumn asChild={true} className="gap-5"><Form>{t6}{t12}{t15}{t17}</Form></FlexColumn>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t17;
    $[38] = t6;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};
const termLinkClassNames = classNames("text-secondary underline", "hover:text-text-secondary/80 focus:text-text-secondary/80 active:text-text-secondary/60");
function _temp(children) {
  return <Link className={termLinkClassNames} href="https://opensea.io/tos" target="_blank">{children}</Link>;
}
function _temp2(children_0) {
  return <Link className={termLinkClassNames} href="https://opensea.io/tosw" target="_blank">{children_0}</Link>;
}
function _temp3(children_1) {
  return <Link className={termLinkClassNames} href="https://opensea.io/privacy" target="_blank">{children_1}</Link>;
}
function _temp4(children_2) {
  return <Link className={termLinkClassNames} href="https://www.privy.io/user-terms-of-service" target="_blank">{children_2}</Link>;
}